// File: src/components/OnboardingBanner.jsx

import React, { useEffect } from 'react';
import './OnboardingBanner.css';

export default function OnboardingBanner({ onDismiss, currentStep = 1, onNextStep }) {
  const wistiaMediaId = 'qd4olhh2zp';

  // Load Wistia player scripts once on mount
  useEffect(() => {
    const scripts = [
      { id: 'wistia-player', src: 'https://fast.wistia.com/player.js' },
      { id: `wistia-media-${wistiaMediaId}`, src: `https://fast.wistia.com/embed/${wistiaMediaId}.js`, module: true },
    ];

    scripts.forEach(({ id, src, module }) => {
      if (document.getElementById(id)) return;
      const s = document.createElement('script');
      s.id = id;
      s.src = src;
      s.async = true;
      if (module) s.type = 'module';
      document.body.appendChild(s);
    });
  }, []);

  return (
    <div className="onboard-banner">
      <h1 className="onboard-title">Welcome to BaoBrain</h1>
      <p className="onboard-subtitle">Let's get your store insights set up in just a few steps</p>

      <div className="video-wrapper">
        <wistia-player
          media-id={wistiaMediaId}
          aspect="1.7777777777777777"
          className="onboard-wistia"
        />
      </div>
      <p className="video-caption">Watch a quick overview of how BaoBrain helps you understand your customers.</p>

      {/* CTA Button */}
      {onNextStep && (
        <div className="cta-section">
          <button className="cta-button" onClick={onNextStep}>
            Continue to Setup
          </button>
        </div>
      )}
    </div>
  );
}